export function capitalizeFirstLetterSafe(value) {
  if (typeof value !== "string" || value.trim() === "") {
    return "---";
  }

  const str = value.trim();
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
